export const GoogleMapApiConfig = 'AIzaSyAUOJWMim452wNe3jnX8c4q-F9gK572Wmg';